import { asyncMiddleware } from '@/router';
import { PasswordRecoveryService } from '@/services/passwordRecovery';
import { APPLICATION_ROUTES } from '@/router/routes_type';

export const passwordReset: asyncMiddleware = async () => {
  if (!PasswordRecoveryService.verification?.isConfirmed) {
    return { name: APPLICATION_ROUTES.PASSWORD_FORGOT };
  }
};
